<template>
    <div class="modal fade" ref="modal">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ modalOptions.title }}</h5>
                    <button type="button"
                            class="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close">
                    </button>
                </div>

                <!-- Generic Modal -->
                <div v-show="modalOptions.property === 'generic'">
                    <div class="modal-body">
                        <div v-html="modalOptions.body"></div>
                    </div>
                    <div class="modal-footer">
                        <button type="button"
                                class="btn btn-secondary"
                                data-bs-dismiss="modal">
                            Close
                        </button>
                        <button type="button"
                                :class="modalOptions.ctaButtonClass"
                                @click="callbackRef()">
                            {{ modalOptions.ctaText }}
                        </button>
                    </div>
                </div>
                <!-- End Generic Modal -->

                <!-- Notification -->
                <div v-show="modalOptions.property === 'notification'">

                    <div class="modal-body">
                        <div class="eco-ui-section-header">
                        Title
                        </div>
                        <input type="text"
                            class="form-control form-control-sm"
                            placeholder="Title"
                            aria-label="Title"
                            name="title"
                            ref="title"
                            :value="modalOptions.titleName"
                            :disabled="true"
                        />
                    </div>

                    <div class="modal-body">
                        <div class="eco-ui-section-header">
                        Event Name
                        </div>
                        <select name="event_name"
                            class="form-select"
                            @change="updateState()"
                            v-model="notification.event_name">
                            <option value="update_state">Update State</option>
                            <option value="attribution">Attribution</option>
                        </select>
                    </div>

                    <div class="modal-body">
                        <div class="eco-ui-section-header">
                        Player ID
                        </div>
                        <input type="text"
                            class="form-control form-control-sm"
                            placeholder="Player ID"
                            aria-label="Player ID"
                            name="player_id"
                            ref="player_id"
                            @input="updateState()"
                            v-model="notification.player_id" />
                    </div>

                    <div class="modal-body">
                        <div class="eco-ui-section-header">
                        Payload
                        </div>
                        <textarea
                            class="form-control form-control-sm payload-textarea"
                            placeholder="Payload"
                            aria-label="Payload"
                            name="payload"
                            ref="payload"
                            v-model="notification.payload" />
                    </div>
                    <div class="modal-footer">
                        <button type="button"
                                class="btn btn-secondary"
                                data-bs-dismiss="modal">
                            Close
                        </button>
                        <button type="button"
                                class="btn btn-danger"
                                @click="callbackRef(notification)">
                            Test
                        </button>
                    </div>
                </div>
                <!-- End Notification -->

            </div>
        </div>
    </div>
</template>

<script>
import { Modal } from 'bootstrap'
import { defineComponent } from 'vue'

export default defineComponent({
    data() {
        return {
            modal: null,
            data: {},
            notification: {
                event_name: "update_state",
                title_id: '',
                player_id: '',
                payload: ''
            }
        }
    },
    props: [
        'modalOptions'
    ],
    mounted() {
    },
    watch: {
        modalOptions: function(newValue) {
           this.data = newValue
           this.updateState();
        }
    },
    methods: {
        updateState() {

            if (this.data.property === 'generic') {
                return
            }

            if (this.notification.event_name === 'update_state') {
                const updateStateTemplate = this.data.templates.update_state
                updateStateTemplate.title_id = this.data.titleId
                updateStateTemplate.player_id = this.notification.player_id
                return this.notification.payload = JSON.stringify(updateStateTemplate)
            }

            if (this.notification.event_name === 'attribution') {
                const attributionTemplate = this.data.templates.attribution
                attributionTemplate.quest_id = Math.floor(Math.random() * 100) + 1
                attributionTemplate.title_id = this.data.titleId
                attributionTemplate.player_id = this.notification.player_id
                attributionTemplate.timestamp = new Date().getTime()
                return this.notification.payload = JSON.stringify(attributionTemplate)
            }
        },
        show() {
            let target = this.$refs['modal']
            this.modal = new Modal(target, {})
            this.modal.show()
        },
        hide() {
            this.modal.hide()
        },
        callbackRef(param = null) {
            if (this.modalOptions.callback) {
                this.modalOptions.callback(param)
            }
            this.modal.hide()
        }
    }
})
</script>
<style scoped>
.payload-textarea {
    min-height: 85px;
}
.modal-body {
    padding: 10px;
}
</style>
